<template>
    <modal id="employee-summary"
           size="large"
           style="height: 100%"
           v-model="showModal"
           :title="$t('employee_summary')"
           :loading="loading"
           :preloader="preloader"
           :hide-footer="hideFooter">
        <div class="col-lg-12">
            <template v-if="summary.data && summary.data.length">
                <table class="table table-bordered">
                    <thead class="thead-dark">
                    <tr>
                        <th>{{ $t('question') }}</th>
                        <th>{{ $t('answer') }}</th>
                        <th>{{ $t('answers.is_correct') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="(item, index) in summary.data"
                        :key="index"
                        :class="item.is_correct ? 'table-success' : 'table-danger'"
                    >
                        <td>{{ item.question?.question_text || '-' }}</td>
                        <td v-if="item.answer_text">{{ item.answer_text }}</td>
                        <td v-else>{{ item.answer?.answer_text || '-' }}</td>
                        <td>{{ item.is_correct ? 'True' : 'False' }}</td>
                    </tr>
                    </tbody>
                </table>
            </template>
            <template v-else>
                <p>{{ $t('no_data_found') }}</p>
            </template>
        </div>
        <template v-if="!hideFooter">
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" @click="onCancel">Cancel</button>
                <button type="button" class="btn btn-primary" @click="onSave">Save</button>
            </div>
        </template>
    </modal>
</template>
<script>
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import {errorMessageInArray} from "../../../../../common/Helper/Support/FormHelper";
import BankDetailsValue from "../../Employee/Components/BankDetails/Components/BankDetailsValue.vue";

export default {
    name: "EmployeeLessonSummary",
    components: {BankDetailsValue},
    mixins: [ModalMixin, FormHelperMixins],
    props: {
        value: {
            type: [Object, Array],
            required: true
        },
        hideFooter: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        summary() {
            return this.value;
        }
    },
    data() {
        return {
            errorMessageInArray,
        };
    },
}
</script>
